import { useRef } from "react";
import { GripVertical, X } from "lucide-react";

// Popover panel: toggle column visibility + drag to reorder. Persisted by the parent.
export function RequestsTableSettings({ columns, setColumns, onClose, colMeta }) {
  const dragIdx = useRef(null);

  const onDrop = (i) => {
    const from = dragIdx.current;
    dragIdx.current = null;
    if (from == null || from === i) return;
    setColumns((cols) => {
      const next = [...cols];
      const [moved] = next.splice(from, 1);
      next.splice(i, 0, moved);
      return next;
    });
  };
  const toggle = (key) => setColumns((cols) => cols.map((c) => (c.key === key ? { ...c, visible: !c.visible } : c)));

  return (
    <div className="absolute right-0 top-full mt-2 z-50 w-72 bg-white rounded-2xl border border-sand-200 shadow-xl p-3" data-testid="req-table-settings" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-1 px-1">
        <span className="text-sm font-bold text-ink">Table settings</span>
        <button data-testid="table-settings-close" onClick={onClose} className="text-ink/40 hover:text-ink"><X className="h-4 w-4" /></button>
      </div>
      <p className="text-[11px] text-ink/50 px-1 mb-2">Show, hide and drag to reorder columns.</p>
      <div className="space-y-0.5">
        {columns.map((c, i) => (
          <div key={c.key} draggable onDragStart={() => (dragIdx.current = i)} onDragOver={(e) => e.preventDefault()} onDrop={() => onDrop(i)}
            data-testid={`col-row-${c.key}`} className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-sand-50 cursor-move">
            <GripVertical className="h-4 w-4 text-ink/25 shrink-0" />
            <span className="flex-1 text-sm text-ink/80 truncate">{colMeta[c.key]?.label || c.key}</span>
            <button type="button" data-testid={`col-toggle-${c.key}`} onClick={() => toggle(c.key)} title={c.visible ? "Hide column" : "Show column"}
              className={`h-5 w-9 rounded-full transition-colors relative shrink-0 ${c.visible ? "bg-redline-500" : "bg-sand-300"}`}>
              <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-all ${c.visible ? "left-[18px]" : "left-0.5"}`} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
